import { AdjudicationAreaWithId } from 'lib/types/adjudicationArea';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import React from 'react';
import { useBooleanFlag } from 'utils/flags';
import { SelectAdjudicationCityDropdown } from './SelectAdjudicationCityDropdown';
import { SelectAdjudicationCountyDropdown } from './SelectAdjudicationCountyDropdown';
import { SelectAdjudicationStateDropdown } from './SelectAdjudicationStateDropdown';

type PublisherLocationFilterFormAdjudicatedProps = {
  selectedState?: AdjudicationAreaWithId;
  selectedCounty?: AdjudicationAreaWithId;
  selectedCity?: AdjudicationAreaWithId;

  onSelectionChanged: (
    dropdown: 'state' | 'county' | 'city',
    value: AdjudicationAreaWithId
  ) => void;
};

export function PublisherLocationFilterFormAdjudicated({
  selectedState,
  selectedCounty,
  selectedCity,
  onSelectionChanged
}: PublisherLocationFilterFormAdjudicatedProps) {
  const isCityFilterEnabled = useBooleanFlag(
    LaunchDarklyFlags.ENABLE_ADJUDICATION_AREA_PLACEMENT_FILTER_CITY,
    false
  );

  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium mb-2">
        Filter by adjudication area
      </legend>
      <SelectAdjudicationStateDropdown
        selectedState={selectedState}
        onStateSelected={value => onSelectionChanged('state', value)}
      />
      <SelectAdjudicationCountyDropdown
        selectedState={selectedState}
        selectedCounty={selectedCounty}
        onCountySelected={value => onSelectionChanged('county', value)}
      />
      {isCityFilterEnabled && (
        <SelectAdjudicationCityDropdown
          selectedState={selectedState}
          selectedCity={selectedCity}
          selectedCounty={selectedCounty}
          onCitySelected={value => onSelectionChanged('city', value)}
        />
      )}
    </fieldset>
  );
}
